import { Form, Select } from "antd";
import { useState } from "react";
import { useIntl } from "react-intl";
import { Link, useParams } from "react-router-dom";
import { useFetchMatchProfiles } from "../../../entities/api";

export const MatchProfileSelect = ({ defaultValue, name }) => {
  const { formatMessage } = useIntl();
  const { customerId, sport, organizationId } = useParams();
  const [value, setValue] = useState(defaultValue);
  const { data: matchProfilesList, isLoading: fetchMatchProfilesLoading } = useFetchMatchProfiles({
    limit: 1000,
  });

  const handleChangeValue = (val) => {
    setValue(val);
  };

  return (
    <>
      <Form.Item name={name} style={{ width: "100%" }}>
        <Select
          showSearch
          value={value}
          disabled={fetchMatchProfilesLoading}
          defaultValue={defaultValue}
          loading={fetchMatchProfilesLoading}
          onChange={handleChangeValue}
          filterOption={(input, option) => (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())}
        >
          <Select.Option value={""}>--</Select.Option>
          {matchProfilesList?.map((profile) => (
            <Select.Option label={profile?.name} value={profile?.profileId} key={profile?.profileId}>
              {profile?.name}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
      {value && (
        <Link to={`/${customerId}/admin/${sport}/${organizationId}/match-profiles/manage/${value}`}>
          {formatMessage({
            id: "view.configuration",
            defaultMessage: "View Configuration",
          })}
        </Link>
      )}
    </>
  );
};
